import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    blockParagraph: p => p.accentWhite,
    link: p => p.primaryLight,
    navbarBg: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    wave: p => p.tertiaryDark,
    border: p => `rgba(${hexToRgb(p.accentWhite)}, 0.3)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.primaryDark,
    blockParagraph: p => p.tertiaryDark,
    link: p => p.primaryDark,
    navbarBg: p => p.tertiaryLight,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    wave: p => p.tertiaryLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.3)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.tertiaryDark,
    blockParagraph: p => p.tertiaryDark,
    link: p => p.primaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    lightBackground: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    wave: p => p.tertiaryExtraLight,
    border: p => `rgba(${hexToRgb(p.tertiaryDark)}, 0.3)`
  }
}
